var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.14,
    height: 17.982,
    viewBox: "0 0 16.14 17.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chain_2",
    "data-name": "chain 2",
    d: "M268.717,175.157V171.69a1.6,1.6,0,0,0-1.594-1.6,1.067,1.067,0,0,1,0-2.133,3.726,3.726,0,0,1,3.719,3.733v3.467a3.726,3.726,0,0,1-3.719,3.733h-1.063a3.726,3.726,0,0,1-3.719-3.733,1.062,1.062,0,1,1,2.125,0,1.6,1.6,0,0,0,1.594,1.6h1.063a1.6,1.6,0,0,0,1.594-1.6Zm-1.594-12.267h-1.063a3.726,3.726,0,0,0-3.719,3.733v3.467a3.726,3.726,0,0,0,3.719,3.733,1.067,1.067,0,0,0,0-2.133,1.6,1.6,0,0,1-1.594-1.6v-3.467a1.6,1.6,0,0,1,1.594-1.6h1.063a1.6,1.6,0,0,1,1.594,1.6,1.062,1.062,0,1,0,2.125,0,3.726,3.726,0,0,0-3.719-3.733Z",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, -112.291, -283.905)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.a0d643edce47c0fa0391912df52dc533.svg";
export { ForwardRef as ReactComponent };